import React from 'react'
import { useDropzone } from 'react-dropzone'
import { 
  Input, 
  Button, 
  Message,
  Icon,
  Loader 
} from 'semantic-ui-react'
import { ACCEPTED_FILE_TYPES } from '../BankReconciliation.constants/INVOICES_TABLE_SMART_INVOICE_SELECTOR'
import './InvoicesTableSmartInvoiceSelector.css'

const InvoicesTableSmartInvoiceSelector = ({
  smartInvoiceSelectorPrompt,
  smartInvoiceSelectorFiles,
  isSmartInvoiceSelectorProcessing,
  smartInvoiceSelectorError,
  onSmartInvoiceSelectorPromptChange,
  onSmartInvoiceSelectorFilesChange,
  onSmartInvoiceSelectorSubmit,
}) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
  } = useDropzone({
    accept: ACCEPTED_FILE_TYPES,
    onDrop: onSmartInvoiceSelectorFilesChange,
    disabled: isSmartInvoiceSelectorProcessing,
  })

  return (
    <div className="invoices-table-smart-invoice-selector">
      <div className="search-bar-container">
        <Input
          icon={<Icon name="search" />}
          placeholder="Décrivez les factures à sélectionner..."
          value={smartInvoiceSelectorPrompt}
          onChange={({ target: { value } }) => onSmartInvoiceSelectorPromptChange(value)}
          disabled={isSmartInvoiceSelectorProcessing}
          className="search-input"
        />
        <Button
          icon
          labelPosition="left"
          onClick={onSmartInvoiceSelectorSubmit}
          disabled={isSmartInvoiceSelectorProcessing || (!smartInvoiceSelectorPrompt && !smartInvoiceSelectorFiles.length)}
          primary
          className="smart-select-button"
        >
          <Icon name="magic" />
          {isSmartInvoiceSelectorProcessing ? (
            <Loader active inline size="tiny" />
          ) : (
            "Sélection intelligente"
          )}
        </Button>
      </div>

      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? "active" : ""} ${isSmartInvoiceSelectorProcessing ? "disabled" : ""}`}
      >
        <input {...getInputProps()} />
        <Icon name="cloud upload" />
        <p>Déposez vos fichiers ici ou cliquez pour sélectionner</p>
      </div>

      {smartInvoiceSelectorFiles.length > 0 && (
        <div className="files-preview">
          {smartInvoiceSelectorFiles.map(({ name }) => (
            <div key={name} className="file-item">
              <Icon name="file outline" />
              <span>{name}</span>
              <Icon
                name="close"
                onClick={() => onSmartInvoiceSelectorFilesChange(
                  smartInvoiceSelectorFiles.filter((f) => f.name !== name),
                )}
              />
            </div>
          ))}
        </div>
      )}

      {smartInvoiceSelectorError && (
        <Message negative size="tiny">
          <p>{smartInvoiceSelectorError}</p>
        </Message>
      )}
    </div>
  )
}

export default InvoicesTableSmartInvoiceSelector 